'use client'

import { createContext, useContext, type ReactNode } from 'react'
import { toolCarouselKey, type ToolCarouselProduct, type ToolCarouselRequest } from '@/lib/tool-carousel-key'

/**
 * FRIDGE-1501 (F2) — products a server page read for its ToolProductCarousels,
 * the card fields only (ToolCarouselProduct). A carousel whose read is here
 * renders its cards in the server HTML and does not fetch again in the
 * browser; any other carousel fetches as before.
 */
const PrefetchedCarousels = createContext<Record<string, ToolCarouselProduct[]>>({})

export function ToolCarouselPrefetch({ products, children }: { products: Record<string, ToolCarouselProduct[]>; children: ReactNode }) {
  return <PrefetchedCarousels.Provider value={products}>{children}</PrefetchedCarousels.Provider>
}

export function usePrefetchedToolCarousel(request: ToolCarouselRequest): ToolCarouselProduct[] | undefined {
  return useContext(PrefetchedCarousels)[toolCarouselKey(request)]
}
